import * as preact from "preact";

import * as accountModal from "accountModal";
import * as modalDialog from "modalDialog";
import models from "models/models";
import * as readerPageNavigation from "readerPageNavigation";
import readlangClient from "readlangClient";
import * as textToSpeech from "textToSpeech";
import DropdownMenu from "views/DropdownMenu";
import ShareBookView from "views/ShareBookView";

interface Props {
  appRouter: any;
  readerViewModel: any;
}

interface State {}

class ReaderPageDropdownMenuView extends preact.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    models.bookModel.on("change:userBook", () => {
      // To update the "Go to furthest location" enabled state
      this.forceUpdate();
    });
  }

  render() {
    return (
      <DropdownMenu
        items={[
          ...(textToSpeech.languageSupported(models.bookModel.get("language"))
            ? [
                {
                  type: "toggle" as const,
                  label: "Speaking Mode",
                  initialValue: models.user.get("speakingMode"),
                  onToggle: (enabled) => {
                    if (enabled && !models.user.hasPremiumAccess()) {
                      accountModal.show({
                        model: models.user,
                        title: "speakingMode",
                        messageHtml:
                          "<h2>Upgrade to enable speaking mode...</h2>" +
                          "<p>Words and phrases will be spoken when you click on them.</p>",
                        showTitle: false,
                      });
                      return false;
                    }

                    models.user.save(
                      { speakingMode: enabled },
                      { patch: true }
                    );
                  },
                },
              ]
            : []),
          {
            type: "action",
            label: "Go to start",
            onClick: () => {
              readerPageNavigation.goToLocation(
                "from",
                0,
                this.props.appRouter
              );
            },
          },
          {
            type: "action",
            label: "Go to furthest read location",
            disabled: !models.bookModel.get("userBook")?.readTo,
            onClick: () => {
              readerPageNavigation.goToLocation(
                "to",
                models.bookModel.get("userBook").readTo,
                this.props.appRouter
              );
            },
          },
          {
            type: "action",
            label: "Go to specific location...",
            onClick: () => {
              readerPageNavigation.showSpecificLocationModal(
                this.props.appRouter,
                this.props.readerViewModel
              );
            },
          },
          {
            type: "action",
            label: "Reset reading progress",
            onClick: async () => {
              if (
                confirm(
                  "Are you sure you want to reset your reading progress for this text?"
                )
              ) {
                await readlangClient.request(
                  "POST",
                  `/api/book/${models.bookModel.id}/resetReadingProgress`,
                  {}
                );
                window.location.href = `/library/${models.bookModel.id}`;
              }
            },
          },
          // The following would be cool to implement but requires a rethink in how we store the
          // text in chunks. Right now we can't even search the whole text easily because we can't
          // map from character position in the plain text to location in the the HTML chunks.
          // {
          //   type: "action",
          //   label: "Find in text...",
          //   onClick: () => {
          //     let inputRef: any;
          //     const onSubmit = () => {
          //       const rawValue = inputRef.value;
          //       const value = parseInt(rawValue, 10);

          //       if (!value) {
          //         alert("Invalid value");
          //         return;
          //       }

          //       if (value < 0 || value > models.bookModel.get("totalWords")) {
          //         alert(
          //           "You need to enter a number between 0 and " +
          //             models.bookModel.get("totalWords")
          //         );
          //         return;
          //       }

          //       this.goToLocation(value);
          //     };

          //     modalDialog.showPreactComponent(
          //       <div>
          //         <p>Enter phrase to find in text:</p>
          //         <input
          //           autoFocus={true}
          //           type="text"
          //           ref={(ref) => (inputRef = ref)}
          //           onKeyDown={(event) => {
          //             if (event.key === "Enter") {
          //               onSubmit();
          //             }
          //           }}
          //         />
          //         <p>
          //           <button
          //             onClick={() => {
          //               onSubmit();
          //             }}
          //           >
          //             Search
          //           </button>
          //         </p>
          //       </div>,
          //       {
          //         heading: "Go to specific location",
          //         onShow: () => {
          //           inputRef.focus();
          //         },
          //       }
          //     );
          //   },
          // },
          ...(models.bookModel.isUserTheOwner() ||
          models.bookModel.get("public")
            ? [
                {
                  type: "action" as const,
                  label: "Share...",
                  onClick: () => {
                    modalDialog.showPreactComponent(<ShareBookView />, {
                      heading: "Share this text",
                    });
                  },
                },
              ]
            : []),
        ]}
      />
    );
  }
}

export default ReaderPageDropdownMenuView;
